import { createElement } from "react";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isEmpty, filter, map, exists, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { RsvpStatusModule_fromInt } from "../Shared/Types.js";
import { t } from "../Lang.js";
import { Rsvp_dash_editSettings, Rsvp_dash_notAllowed, Rsvp_dash_allowed, Rsvp_dash_plusOneLabel, Rsvp_dash_deadlineLabel, Rsvp_dash_statusClosed, Rsvp_dash_statusOpen, Rsvp_dash_statusLabel, Rsvp_dash_notConfigured, Rsvp_dash_total, Rsvp_dash_management, Rsvp_dash_experimentalDesc, Rsvp_dash_experimentalTitle, Rsvp_dash_mealPreferences, Rsvp_dash_notGenerated, Rsvp_dash_copy, Rsvp_dash_link, Rsvp_dash_status, Rsvp_dash_guest, Rsvp_dash_noGuests, Rsvp_dash_copyAllLinks, Rsvp_dash_generateLinks, Rsvp_dash_guestLinks, Rsvp_dash_cancel, Rsvp_dash_save, Rsvp_dash_confirmationPlaceholder, Rsvp_dash_confirmationMessage, Rsvp_dash_mealPlaceholder, Rsvp_dash_mealOptions, Rsvp_dash_allowPlusOne, Rsvp_dash_deadline, Rsvp_dash_acceptRsvps, Rsvp_dash_settings, Rsvp_dash_notSent, Rsvp_dash_maybe, Rsvp_dash_declined, Rsvp_dash_accepted, Rsvp_dash_pending } from "../Shared/Tr.js";
import { collect, map as map_1, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { Msg } from "../App/Messages.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { map as map_2, defaultArg } from "../fable_modules/fable-library-js.4.28.0/Option.js";

function summaryCard(label, count, colorClass) {
    let elems;
    return createElement("div", createObj(ofArray([["className", `rsvp-stat-card ${colorClass}`], (elems = [createElement("div", {
        className: "rsvp-stat-count",
        children: int32ToString(count),
    }), createElement("div", {
        className: "rsvp-stat-label",
        children: label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function statusLabel(status) {
    const matchValue = RsvpStatusModule_fromInt(status);
    switch (matchValue.tag) {
        case 1:
            return t(Rsvp_dash_pending);
        case 2:
            return t(Rsvp_dash_accepted);
        case 3:
            return t(Rsvp_dash_declined);
        case 4:
            return t(Rsvp_dash_maybe);
        default:
            return t(Rsvp_dash_notSent);
    }
}

function statusBadgeClass(status) {
    const matchValue = RsvpStatusModule_fromInt(status);
    switch (matchValue.tag) {
        case 1:
            return "badge badge-warning";
        case 2:
            return "badge badge-success";
        case 3:
            return "badge badge-danger";
        case 4:
            return "badge badge-info";
        default:
            return "badge badge-secondary";
    }
}

function configForm(form, dispatch) {
    let elems_8;
    return createElement("div", createObj(ofArray([["className", "rsvp-config-form card"], (elems_8 = toList(delay(() => append(singleton(createElement("h4", {
        children: t(Rsvp_dash_settings),
    })), delay(() => {
        let elems_1, elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", createObj(singleton_1((elems = [createElement("input", {
            type: "checkbox",
            checked: form.IsOpen,
            onChange: (ev) => {
                dispatch(new Msg(252, [ev.target.checked]));
            },
        }), " " + t(Rsvp_dash_acceptRsvps)], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
                children: t(Rsvp_dash_deadline),
            }), createElement("input", {
                type: "date",
                className: "form-control",
                value: form.Deadline,
                onChange: (ev_1) => {
                    dispatch(new Msg(253, [ev_1.target.value]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_4, elems_3;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_4 = [createElement("label", createObj(singleton_1((elems_3 = [createElement("input", {
                    type: "checkbox",
                    checked: form.AllowPlusOne,
                    onChange: (ev_2) => {
                        dispatch(new Msg(254, [ev_2.target.checked]));
                    },
                }), " " + t(Rsvp_dash_allowPlusOne)], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let elems_5;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_5 = [createElement("label", {
                        children: t(Rsvp_dash_mealOptions),
                    }), createElement("input", {
                        type: "text",
                        className: "form-control",
                        value: form.MealOptions,
                        placeholder: t(Rsvp_dash_mealPlaceholder),
                        onChange: (ev_3) => {
                            dispatch(new Msg(255, [ev_3.target.value]));
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                        let elems_6;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_6 = [createElement("label", {
                            children: t(Rsvp_dash_confirmationMessage),
                        }), createElement("textarea", {
                            className: "form-control",
                            value: form.ConfirmationMessage,
                            placeholder: t(Rsvp_dash_confirmationPlaceholder),
                            onChange: (ev_4) => {
                                dispatch(new Msg(256, [ev_4.target.value]));
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                            let matchValue;
                            return append((matchValue = form.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
                                className: "text-danger text-sm",
                                children: matchValue,
                            }))), delay(() => {
                                let elems_7;
                                return singleton(createElement("div", createObj(ofArray([["className", "form-actions"], (elems_7 = [createElement("button", {
                                    className: "btn btn-primary",
                                    children: t(Rsvp_dash_save),
                                    disabled: form.IsSubmitting,
                                    onClick: (_arg) => {
                                        dispatch(new Msg(257, []));
                                    },
                                }), createElement("button", {
                                    className: "btn btn-secondary",
                                    children: t(Rsvp_dash_cancel),
                                    onClick: (_arg_1) => {
                                        dispatch(new Msg(261, []));
                                    },
                                })], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

function guestLinksTable(links, eventId, dispatch) {
    let elems_3;
    return createElement("div", createObj(ofArray([["className", "rsvp-guest-links"], (elems_3 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "rsvp-links-header"], (elems_1 = [createElement("h4", {
            children: t(Rsvp_dash_guestLinks),
        }), createElement("div", createObj(ofArray([["className", "rsvp-links-actions"], (elems = toList(delay(() => append(singleton(createElement("button", {
            className: "btn btn-primary btn-sm",
            children: t(Rsvp_dash_generateLinks),
            onClick: (_arg) => {
                dispatch(new Msg(259, [eventId]));
            },
        })), delay(() => (exists((l) => (l.GuestToken !== ""), links) ? singleton(createElement("button", {
            className: "btn btn-secondary btn-sm",
            children: t(Rsvp_dash_copyAllLinks),
            onClick: (_arg_1) => {
                const allLinks = join("\n", map((l_2) => (`${l_2.GuestName}: ${window.location.origin}/rsvp/${eventId}/${l_2.GuestToken}`), filter((l_1) => (l_1.GuestToken !== ""), links)));
                navigator.clipboard.writeText(allLinks);
            },
        })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2, children_2, children, children_10;
            return isEmpty(links) ? singleton(createElement("p", {
                className: "text-muted",
                children: t(Rsvp_dash_noGuests),
            })) : singleton(createElement("table", createObj(ofArray([["className", "table rsvp-links-table"], (elems_2 = [(children_2 = singleton_1((children = ofArray([createElement("th", {
                children: t(Rsvp_dash_guest),
            }), createElement("th", {
                children: t(Rsvp_dash_status),
            }), createElement("th", {
                children: t(Rsvp_dash_link),
            })]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children)),
            }))), createElement("thead", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            })), (children_10 = toList(delay(() => map_1((link) => {
                let children_4, children_6;
                const children_8 = ofArray([createElement("td", {
                    children: link.GuestName,
                }), (children_4 = singleton_1(createElement("span", {
                    className: statusBadgeClass(link.Status),
                    children: statusLabel(link.Status),
                })), createElement("td", {
                    children: reactApi.Children.toArray(Array.from(children_4)),
                })), (children_6 = toList(delay(() => {
                    if (link.GuestToken !== "") {
                        const url = `${window.location.origin}/rsvp/${eventId}/${link.GuestToken}`;
                        return singleton(createElement("button", {
                            className: "btn btn-link btn-sm",
                            children: t(Rsvp_dash_copy),
                            title: url,
                            onClick: (_arg_2) => {
                                navigator.clipboard.writeText(url);
                            },
                        }));
                    }
                    else {
                        return singleton(createElement("span", {
                            className: "text-muted text-sm",
                            children: t(Rsvp_dash_notGenerated),
                        }));
                    }
                })), createElement("td", {
                    children: reactApi.Children.toArray(Array.from(children_6)),
                }))]);
                return createElement("tr", {
                    children: reactApi.Children.toArray(Array.from(children_8)),
                });
            }, links))), createElement("tbody", {
                children: reactApi.Children.toArray(Array.from(children_10)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function mealCountsSection(counts) {
    let elems_2, elems_1;
    if (isEmpty(counts)) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(ofArray([["className", "rsvp-meal-counts card"], (elems_2 = [createElement("h4", {
            children: t(Rsvp_dash_mealPreferences),
        }), createElement("div", createObj(ofArray([["className", "meal-counts-grid"], (elems_1 = toList(delay(() => collect((matchValue) => {
            let elems;
            return singleton(createElement("div", createObj(ofArray([["className", "meal-count-item"], (elems = [createElement("span", {
                className: "meal-name",
                children: matchValue[0],
            }), createElement("span", {
                className: "meal-count badge",
                children: int32ToString(matchValue[1]),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }, counts))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }
}

export function view(es, dispatch) {
    let elems_5;
    const eventId = defaultArg(map_2((e) => e.Id, es.Event), "");
    return createElement("div", createObj(ofArray([["className", "rsvp-dashboard"], (elems_5 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "rsvp-experimental-banner"], (elems_1 = [createElement("span", {
            className: "rsvp-experimental-icon",
            children: "🧪",
        }), createElement("div", createObj(singleton_1((elems = [createElement("strong", {
            children: t(Rsvp_dash_experimentalTitle),
        }), createElement("p", {
            children: t(Rsvp_dash_experimentalDesc),
        })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(createElement("h3", {
            children: t(Rsvp_dash_management),
        })), delay(() => {
            let matchValue, summary, elems_2;
            return append((matchValue = es.RsvpSummary, (matchValue == null) ? singleton(defaultOf()) : ((summary = matchValue, append(singleton(createElement("div", createObj(ofArray([["className", "rsvp-summary-grid"], (elems_2 = [summaryCard(t(Rsvp_dash_accepted), summary.Accepted, "stat-success"), summaryCard(t(Rsvp_dash_declined), summary.Declined, "stat-danger"), summaryCard(t(Rsvp_dash_maybe), summary.Maybe, "stat-info"), summaryCard(t(Rsvp_dash_pending), summary.Pending, "stat-warning"), summaryCard(t(Rsvp_dash_notSent), summary.NotSent, "stat-secondary"), summaryCard(t(Rsvp_dash_total), summary.TotalGuests, "stat-primary")], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => singleton(mealCountsSection(summary.MealCounts))))))), delay(() => {
                let matchValue_1, elems_4;
                return append((matchValue_1 = es.RsvpConfigForm, (matchValue_1 == null) ? singleton(createElement("div", createObj(ofArray([["className", "rsvp-config-summary card"], (elems_4 = toList(delay(() => append(singleton(createElement("h4", {
                    children: t(Rsvp_dash_settings),
                })), delay(() => {
                    let matchValue_2, config, elems_3;
                    return append((matchValue_2 = es.RsvpConfig, (matchValue_2 == null) ? singleton(createElement("p", {
                        className: "text-muted",
                        children: t(Rsvp_dash_notConfigured),
                    })) : ((config = matchValue_2, singleton(createElement("div", createObj(ofArray([["className", "config-details"], (elems_3 = toList(delay(() => {
                        let children;
                        return append(singleton((children = ofArray([t(Rsvp_dash_statusLabel), createElement("strong", {
                            children: config.IsOpen ? t(Rsvp_dash_statusOpen) : t(Rsvp_dash_statusClosed),
                        })]), createElement("p", {
                            children: reactApi.Children.toArray(Array.from(children)),
                        }))), delay(() => {
                            let matchValue_3, d, children_2;
                            return append((matchValue_3 = config.Deadline, (matchValue_3 == null) ? singleton(defaultOf()) : ((d = matchValue_3, singleton((children_2 = ofArray([t(Rsvp_dash_deadlineLabel), createElement("strong", {
                                children: d,
                            })]), createElement("p", {
                                children: reactApi.Children.toArray(Array.from(children_2)),
                            })))))), delay(() => {
                                let children_4;
                                return singleton((children_4 = ofArray([t(Rsvp_dash_plusOneLabel), createElement("strong", {
                                    children: config.AllowPlusOne ? t(Rsvp_dash_allowed) : t(Rsvp_dash_notAllowed),
                                })]), createElement("p", {
                                    children: reactApi.Children.toArray(Array.from(children_4)),
                                })));
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))))), delay(() => singleton(createElement("button", {
                        className: "btn btn-secondary btn-sm",
                        children: t(Rsvp_dash_editSettings),
                        onClick: (_arg) => {
                            dispatch(new Msg(251, []));
                        },
                    }))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : singleton(configForm(matchValue_1, dispatch))), delay(() => singleton(guestLinksTable(es.RsvpGuestLinks, eventId, dispatch))));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

